import { Module } from 'vuex/types';
import { ModuleAState, RootState } from '~/types/store';

const moduleA: Module<ModuleAState, RootState> = {
  state: () => ({
    name: 'moduleA',
  }),
  mutations: {},
  actions: {},
  getters: {},
};

export default moduleA;
